var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M17.2 16H22.8C23.9201 16 24.4802 16 24.908 16.218C25.2843 16.4097 25.5903 16.7157 25.782 17.092C26 17.5198 26 18.0799 26 19.2V29H22C22 27.3431 20.6569 26 19 26C17.3495 26 16.0104 27.3328 16.0001 28.9808C15.6078 28.9569 15.3295 28.903 15.092 28.782C14.7157 28.5903 14.4097 28.2843 14.218 27.908C14 27.4802 14 26.9201 14 25.8V19.2C14 18.0799 14 17.5198 14.218 17.092C14.4097 16.7157 14.7157 16.4097 15.092 16.218C15.5198 16 16.0799 16 17.2 16Z",
    fill: "#0C5D53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19H28.3373C28.5818 19 28.7041 19 28.8192 19.0276C28.9213 19.0521 29.0188 19.0925 29.1083 19.1474C29.2092 19.2092 29.2957 19.2957 29.4686 19.4686L33.5314 23.5314C33.7043 23.7043 33.7908 23.7908 33.8526 23.8917C33.9075 23.9812 33.9479 24.0787 33.9724 24.1808C34 24.2959 34 24.4182 34 24.6627V27.5C34 27.9659 34 28.1989 33.9239 28.3827C33.8224 28.6277 33.6277 28.8224 33.3827 28.9239C33.1989 29 32.9659 29 32.5 29M27.5 29H26M26 29V19.2C26 18.0799 26 17.5198 25.782 17.092C25.5903 16.7157 25.2843 16.4097 24.908 16.218C24.4802 16 23.9201 16 22.8 16H17.2C16.0799 16 15.5198 16 15.092 16.218C14.7157 16.4097 14.4097 16.7157 14.218 17.092C14 17.5198 14 18.0799 14 19.2V27C14 28.1046 14.8954 29 16 29M26 29H22M22 29C22 30.6569 20.6569 32 19 32C17.3431 32 16 30.6569 16 29M22 29C22 27.3431 20.6569 26 19 26C17.3431 26 16 27.3431 16 29M32.5 29.5C32.5 30.8807 31.3807 32 30 32C28.6193 32 27.5 30.8807 27.5 29.5C27.5 28.1193 28.6193 27 30 27C31.3807 27 32.5 28.1193 32.5 29.5Z",
    stroke: "#0C5D53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.2d9cc1640ba76f82407ca43231597a0c.svg";
export { ForwardRef as ReactComponent };